export default {
    controlHub: {
        tabs: {
            containerSummary: "Riepilogo Container",
            companyStats: "Statistiche Azienda",
        },
        timeRange: {
            thisMonth: "Questo Mese",
            last3Months: "Ultimi 3 Mesi",
            last6Months: "Ultimi 6 Mesi",
            last9Months: "Ultimi 9 Mesi",
            thisYear: "Quest'Anno",
        },
        stats: {
            activePartners: "Partner Attivi",
            teamMembers: "Membri del Team",
        },
        tooltips: {
            docIssues: {
                title: "Container con problemi documentali",
                description: "Numero di container con almeno un problema documentale attivo (documenti mancanti, controlli falliti, errori di cross-check)",
            },
            issues: {
                title: "Problemi",
                description: "Totale problemi attivi su tutti i container",
            },
            atRisk: {
                title: "Spedizioni a rischio",
                description: "Container con punteggio di rischio ≥ 25% (medio, alto, critico)",
            },
            highRisk: {
                title: "Spedizioni ad Alto Rischio",
                description: "Container con punteggio di rischio ≥ 50% che richiedono attenzione",
            },
            activePartners: {
                title: "Partner Commerciali Attivi",
                description: "Aziende con cui hai spedizioni attive (destinatari, spedizionieri)",
            },
            teamMembers: {
                title: "Membri del Team Attivi",
                description: "Utenti nella tua organizzazione con accesso a questo workspace",
            },
        },
        riskyShipments: {
            title: "Spedizioni a Rischio",
            description: "Container ad alto rischio ordinati per valore a rischio",
            emptyState: "Nessuna spedizione ad alto rischio trovata",
        },
        companyProfile: {
            title: "Profilo Aziendale",
            profileCompleteness: "Completezza Profilo",
            tradingPattern: "Pattern Commerciale",
            volumeTier: "Livello Volume",
            commodities: "Merci",
            tradeRoutes: "Rotte Commerciali",
            partners: "Partner Commerciali",
            containers: "Attività Container",
            topHsCodes: "Top Codici HS",
            topRoutes: "Top Rotte Commerciali",
        },
    },
    admin: {
        title: "Dashboard",
        subtitle: "Panoramica del sistema e gestione accounts",
        newAccount: "Nuovo Account",
        loading: "Caricamento dashboard...",
        stats: {
            totalAccounts: "Totale Accounts",
            activeAccounts: "Accounts Attivi",
            newThisMonth: "Nuovi Questo Mese",
            suspendedAccounts: "Accounts Sospesi",
        },
        recentAccounts: {
            title: "Accounts Recenti",
            description: "Ultimi 5 accounts creati nel sistema",
            viewAll: "Vedi tutti",
            headers: {
                userType: "User Type",
                legalName: "Nome Legale",
                entityType: "Tipo Entità",
                country: "Paese",
                status: "Stato",
                createdAt: "Data Creazione",
            },
            status: {
                active: "Attivo",
                suspended: "Sospeso",
                inactive: "Inattivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
            containersWithDocIssues: "Con problemi doc",
            issues: "Con problemi",
            atRisk: "A rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Panoramica dei container ricevuti e collaborazioni",
        loading: "Caricamento dashboard...",
        newOrderRequest: "Richiesta Nuovo Ordine",
        manageShippers: "Gestisci Spedizionieri",
        viewContainers: "Vedi Container",
        newOrderModal: {
            title: "Nuova Richiesta Ordine",
            shipper: "Spedizioniere",
            shipperPlaceholder: "Seleziona un spedizioniere",
            targetWeek: "Settimana Target",
            packingList: "Packing List Richiesta",
            packingListPlaceholder: "Descrivi in dettaglio la packing list richiesta...",
            notes: "Note",
            notesPlaceholder: "Note aggiuntive sull'ordine...",
            submit: "Crea Ordine"
        },
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container ricevuti",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                shipper: "Spedizioniere",
                route: "Route",
                progress: "Progress",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
            },
        },
        monthlyTrend: {
            title: "Andamento Mensile",
        },
        trendVsLastMonth: "vs mese scorso",
        receivedContainers: "Container Ricevuti",
        activeShippers: "Spedizionieri Attivi",
        charts: {
            commodityDistribution: "Distribuzione Commodity",
            originCountries: "Paesi di Origine",
            arrivalPorts: "Porti di Arrivo",
        },
    },
};
